import {useFormikContext, withFormik} from "formik";
import {t} from "i18next";

import DateInput from "../../../utilities/Inputs/DateInput";
import {Select} from "../../../utilities/Inputs/SelectField";
import TextAreaInput from "../../../utilities/Inputs/TextAreaInput";
import TextInput from "../../../utilities/Inputs/TextInput";
import withActionsDependent from "../ActionsDependentHoc/ActionsDependent.hoc";
import {ACTION_TYPES} from "../constants";
import SkuActionTable from "../SkuActionTable/SkuActionTable";

import ManagersSelect from "./common/ManagersSelect";
import SampleActionCase from "./common/SampleActionCase";
import useSampleActionBase from "./useSampleActionBase";

const SampleActionBase = ({actionType}) => {
  const {values} = useFormikContext();

  const {
    onTakeToReportBtnClick,
    onVerifyInventoryBtnClick,
    // onWriteOffBtnClick,
    loading,
    images,
    onTakeToReportRMBtnClick,
    onGoBackBtnClick,
    onReturnFromReportBtnClick,
    onGiveToReportBtnClick,
    onRestoreFromReportBtnClick,
    restoreFromReportTableColumns,
    restoreFromReportTableData,
    onMoveToWarehouseBtnClick,
    warehouseOptions,
    managerOptions,
    onWriteOffToWarehouseBtnClick,
  } = useSampleActionBase({
    actionType,
  });

  switch (actionType) {
    case ACTION_TYPES.takeToReport:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onTakeToReportBtnClick}
          isLeftBtnDisabled={!values.dateTo || !values.note}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Take in report"
          title="Take sample under report"
        >
          <DateInput label={t("Report BEFORE:")} name="dateTo" isRowLayout />
          <TextInput label={t("Manager ")} name={"manager"} width={"100%"} readOnly inputclassname="skuInput" />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} required />
        </SampleActionCase>
      );
    case ACTION_TYPES.returnFromReport:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onReturnFromReportBtnClick}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Return from report"
          title="Return sample from report"
        >
          <DateInput label={t("Report BEFORE:")} name="dateTo" isRowLayout readOnly={true} />
          <TextInput label={t("Brand Manager")} name={"brandManager"} width={"100%"} readOnly={true} />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} readOnly={true} />
        </SampleActionCase>
      );
    case ACTION_TYPES.giveToReport:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onGiveToReportBtnClick}
          isLeftBtnDisabled={!values.dateTo || !values.note || !values.reportForManagerId}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Give to report"
          title="Give sample to report"
        >
          <DateInput label={t("Report BEFORE:")} name="dateTo" isRowLayout />
          <ManagersSelect />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} />
        </SampleActionCase>
      );
    case ACTION_TYPES.restoreFromReport:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onRestoreFromReportBtnClick}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Restore from report"
          title="Restore sample from report"
          nearImgPart={<DateInput label={t("Report BEFORE:")} name="dateTo" readOnly />}
        >
          <TextInput label={t("Report Manager")} name={"reportManager"} width={"100%"} readOnly />
          <SkuActionTable
            data={restoreFromReportTableData}
            actionType={actionType}
            loading={loading}
            columns={restoreFromReportTableColumns}
            // height="100px"
          />
        </SampleActionCase>
      );
    case ACTION_TYPES.toWarehouse:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onMoveToWarehouseBtnClick}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Move"
          title="Move sample to warehouse"
          nearImgPart={<DateInput label={t("Report BEFORE:")} name="dateTo" readOnly />}
        >
          <Select label={t("Warehouse")} name={"warehouse"} width={"100%"} options={warehouseOptions} disabled />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} />
        </SampleActionCase>
      );
    case ACTION_TYPES.inventory:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onVerifyInventoryBtnClick}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Verify"
          title="Verify sample from report"
          nearImgPart={<DateInput label={t("Inventory Date:")} name="inventoryDate" readOnly />}
        >
          <TextInput label={t("Manager ")} name={"manager"} width={"100%"} readOnly />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} />
        </SampleActionCase>
      );
    case ACTION_TYPES.forWriteOffWarehouse:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onWriteOffToWarehouseBtnClick}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Write off"
          title="Write off the sample (warehouse)"
          nearImgPart={<DateInput label={t("Write off date:")} name="writeOffDate" readOnly />}
        >
          <Select label={t("Warehouse")} name={"warehouse"} width={"100%"} options={warehouseOptions} disabled />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} />
        </SampleActionCase>
      );
    case ACTION_TYPES.takeToReportRM:
      return (
        <SampleActionCase
          images={images}
          onLeftBtnClick={onTakeToReportRMBtnClick}
          isLeftBtnDisabled={!values.dateTo || !values.note}
          onRightBtnClick={onGoBackBtnClick}
          leftBtnName="Take in report RM"
          title="Take sample under report (report RM)"
        >
          <DateInput label={t("Write off date:")} name="dateTo" isRowLayout />
          <TextInput label={t("Manager ")} name={"manager"} width={"100%"} readOnly={true} inputclassname="skuInput" />
          <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} />
        </SampleActionCase>
      );
    // case ACTION_TYPES.forWriteOff:
    //   return (
    //     <SampleActionCase
    //       images={images}
    //       onLeftBtnClick={onWriteOffBtnClick}
    //       onRightBtnClick={onGoBackBtnClick}
    //       leftBtnName="Write off"
    //       title="Write off the sample"
    //     >
    //       <DateInput label={t("Write off date:")} name="writeOffDate" isRowLayout />
    //       <TextInput
    //         label={t("Brand Manager")}
    //         name={"brandManager"}
    //         width={"100%"}
    //         readOnly={true}
    //         inputclassname="skuInput"
    //       />
    //       <TextAreaInput name={"note"} placeholder={t("Note")} height={"55px"} readOnly required />
    //     </SampleActionCase>
    //   );

    default:
      return <div className="fc aic jcc w100 h100">{t("Wrong URL")}</div>;
  }
};

export default withActionsDependent(withFormik({enableReinitialize: true})(SampleActionBase));
